import React, { useState } from "react";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import { CalculatorSteps } from "../types";
import fetchRidgeAccessories from "../helpers/fetchRidgeAccessories";
import { useSiteContext } from "../../Site";
import { useAnalyticsContext } from "../helpers/analytics";
import type { Data, Underlay, TileOptionSelections } from "../types";
import type { Values } from "@bmi-digital/components/form";

const getUnderlayByProductCode = (
  externalProductCode: string,
  data: Data
): Underlay | undefined =>
  data.underlays.find(
    (underlay) => underlay.externalProductCode === externalProductCode
  );

const useUnderlaySelection = ({
  setSelectedStep,
  tileOptions,
  setTileOptions,
  esIndexNameProduct,
  data
}: {
  setSelectedStep: (step: CalculatorSteps) => void;
  tileOptions?: TileOptionSelections;
  setTileOptions: (tileOptions?: TileOptionSelections) => void;
  esIndexNameProduct?: string;
  data: Data;
}) => {
  const [underlay, setUnderlay] = useState<Underlay | undefined>(undefined);
  const { getMicroCopy } = useSiteContext();
  const pushEvent = useAnalyticsContext();

  const handleUnderlaySelection = async (
    event: React.FormEvent,
    value: Values
  ) => {
    event.preventDefault();

    pushEvent({
      event: "dxb.button_click",
      id: "rc-select-underlay",
      label: getMicroCopy(microCopy.UNDERLAY_SELECTION_NEXT_LABEL),
      action: "selected"
    });

    if (value.underlay) {
      const underlayProduct = getUnderlayByProductCode(
        //The Form type needs to be fixed in the common components
        // to avoid type casting
        value.underlay as string,
        data
      );
      setUnderlay(underlayProduct);
    }

    if (!Object.keys(data.gutters).length) {
      await fetchRidgeAccessories({
        tileOptions,
        setTileOptions,
        esIndexNameProduct
      });
      setSelectedStep(CalculatorSteps.YourSolutionContains);
      return;
    }

    setSelectedStep(CalculatorSteps.Guttering);
  };

  return { handleUnderlaySelection, underlay, setUnderlay };
};

export default useUnderlaySelection;
